/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { isJDXHomePage, isSRSMFlag } from "./../../../environments/config";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { icons } from "../../../environments/config";
import { Subscription } from "rxjs";
@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit, OnDestroy {
  public whiteShopLogo;
  public srsmLogo;
  public jdxLogo;
  public highlineLogo;
  public fbLogo = icons.footerIcons.fb;
  public linkedInLogo = icons.footerIcons.linkedIn;
  public instagramLogo = icons.footerIcons.instagram;
  public youTubeLogo = icons.footerIcons.youTube;
  public twitterLogo = icons.footerIcons.twitter;
  public fbFooterLogoColored = icons.footerIcons.fbFooterColored;
  public linkedInFooterLogoColored = icons.footerIcons.linkedInFooterColored;
  public instagramFooterLogoColored = icons.footerIcons.instagramFooterColored;
  public youTubeFooterLogoColored = icons.footerIcons.youTubeFooterColored;
  public twitterFooterLogoColored = icons.footerIcons.twitterFooterColored;
  public faceBookLink;
  public twitterLink;
  public instaGramLink;
  public youTubeLink;
  public linkedInLink;
  public footerText;
  public addresses;
  public companyLogo;
  public currentYear;
  public isClient: any;
  user;
  subscriptions: Subscription[] = [];
  constructor(public localStorageService: LocalStorageService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.localStorageService.islocalStorageChannelsUpdated.subscribe(
        (isUpdated) => {
          if (isUpdated) {
            this.getChannels();
          }
        }
      )
    );
    this.getChannels();
    if (
      window.location.href.includes("srsm") ||
      window.location.href.includes("srshopping")
    ) {
      this.isClient = "srsm";
      this.whiteShopLogo = this.srsmLogo;
    } else if (
      isJDXHomePage.flag &&
      !isJDXHomePage.isHighLine &&
      !window.location.hostname.includes("salesdemo")
    ) {
      this.isClient = "jdx";
    } else if (isJDXHomePage.isHighLine) {
      this.isClient = "highlineunitedmarketplace";
    }
    this.currentYear = new Date().getFullYear();
  }
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  redirectPoweredBy() {
    window.open("https://shopconnect.live");
  }
  isUserConsumer() {
    let index = -1;
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user && this.user.companies && this.user.companies.length) {
      index = this.user.companies.findIndex((company) => company.consumer);
      if (index < 0 && this.user.type && this.user.type === "B2C") {
        index = 0;
      }
    }
    return index >= 0;
  }
  getChannels() {
    let config = JSON.parse(
      localStorage.getItem("config")
        ? localStorage.getItem("config")
        : localStorage.getItem("companyConfig")
    );
    if (config) {
      this.addresses =
        config.whiteshop.addresses && config.whiteshop.addresses.length > 3
          ? config.whiteshop.addresses.splice(0, 3)
          : config.whiteshop.addresses;
      this.footerText = config.whiteshop.footerText;
      if (config.whiteshop.companyLogo && config.whiteshop.companyLogo.length) {
        this.whiteShopLogo = config.whiteshop.companyLogo;
      } else if (isSRSMFlag.flag) {
        this.whiteShopLogo = icons.srsmIcon.srsmIcon;
      } else if (isJDXHomePage.flag && !isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.jdxIcon.jdxLogo;
      } else if (isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.highlineIcon.logo;
      } else {
        this.whiteShopLogo = icons.whiteShopIcon.icon;
      }
    } else {
      if (isSRSMFlag.flag) {
        this.whiteShopLogo = icons.srsmIcon.srsmIcon;
      } else if (isJDXHomePage.flag && !isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.jdxIcon.jdxLogo;
      } else if (isJDXHomePage.isHighLine) {
        this.whiteShopLogo = icons.highlineIcon.logo;
      } else {
        this.whiteShopLogo = icons.whiteShopIcon.icon;
      }
    }
    if (
      config &&
      !config.channels.facebookUrl &&
      !config.channels.twitterUrl &&
      !config.channels.linkedinUrl &&
      !config.channels.youtubeUrl &&
      !config.channels.instagramUrl
    ) {
      if (isJDXHomePage.flag && !isJDXHomePage.isHighLine) {
        this.faceBookLink = "https://www.facebook.com/JDXSUITE/";
        this.twitterLink = "https://twitter.com/JdxSuite";
        this.linkedInLink = "https://www.linkedin.com/company/jdx-suite/";
        this.youTubeLink =
          "https://www.youtube.com/channel/UCxDd-q1eBbdQlmEWRe0HZBA";
        this.instaGramLink = "https://www.instagram.com/jdx_suite/";
      } else {
        this.faceBookLink = "https://www.facebook.com/ShopConnect.Live";
        this.twitterLink = "https://twitter.com/ShopConnectLive";
        this.instaGramLink = "https://www.instagram.com/shopconnect.live/";
        this.youTubeLink =
          "https://www.youtube.com/channel/UCccG8Hbr5uiQyL_w4UMxRkg/";
        this.linkedInLink = "http://linkedin.com/company/shopconnectlive";
      }
    } else {
      this.faceBookLink =
        config && config.channels && config.channels.facebookUrl
          ? config.channels.facebookUrl
          : "";
      this.twitterLink =
        config && config.channels && config.channels.twitterUrl
          ? config.channels.twitterUrl
          : "";
      this.linkedInLink =
        config && config.channels && config.channels.linkedinUrl
          ? config.channels.linkedinUrl
          : "";
      this.youTubeLink =
        config && config.channels && config.channels.youtubeUrl
          ? config.channels.youtubeUrl
          : "";
      this.instaGramLink =
        config && config.channels && config.channels.instagramUrl
          ? config.channels.instagramUrl
          : "";
    }
  }
  isMobileDevice() {
    return window.innerWidth <= 600;
  }
}
